/* eslint-disable prefer-destructuring */
import parserTag from './parsergoogletag';

export const VIDEO_TYPE = {
  YOUTUBE: 'YOUTUBE',
  VIMEO: 'VIMEO',
  HTML: 'HTML',
  FLASH: 'FLASH',
  JAVASCRIPT: 'JAVASCRIPT',
  SWF: 'SWF',
  UNKNOWN: 'UNKNOWN',
  IMA: 'IMA',
  AUDIO: 'AUDIO',
  AUDIO_LIVE: 'audio_live',
  VIDEO_LIVE: 'video_live',
  HLS: 'HLS',
};
export const SOURCE_TYPE = {
  EXTERNAL: 'EXTERNAL',
  SMARTY: 'SMARTY',
};
export function checkProtocol(url) {
  if (url.indexOf('//') === 0) {
    // eslint-disable-next-line no-undef
    return document.location.protocol + url;
  }
  return url;
}

function extractHostname(url) {
  let hostname = '';
  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  }

  // find & remove port number
  hostname = hostname.split(':')[0];
  //  find & remove "?"
  hostname = hostname.split('?')[0];

  return hostname;
}

export function extractRootDomain(url) {
  let domain = extractHostname(url);
  const splitArr = domain.split('.');
  const arrLen = splitArr.length;

  // extracting the root domain here
  // if there is a subdomain
  if (arrLen > 2) {
    domain = `${splitArr[arrLen - 2]}.${splitArr[arrLen - 1]}`;
    // check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
    if (splitArr[arrLen - 1].length === 2 && splitArr[arrLen - 1].length === 2) {
      // this is using a ccTLD
      domain = `${splitArr[arrLen - 3]}.${domain}`;
    }
  }
  return domain;
}

export function isIMAVideo(url) {
  if (
    extractRootDomain(url) === 'doubleclick.net' ||
    extractRootDomain(url) === 'googlesyndication.com' ||
    extractRootDomain(url) === 'googleapis.com'
  ) {
    //  || (extractRootDomain(url) === 'googleapis.com'))  {
    return true;
  }
  return false;
}

function isExternalVideo(url) {
  if (extractRootDomain(url) === 'playoncenter.com') {
    return false;
  }
  return true;
}
function getIdVideoYoutube(url) {
  let youtubeId = '';
  if (url.match('embed')) {
    youtubeId = url.split(/embed\//)[1].split('"')[0];
  } else {
    youtubeId = url.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0];
  }
  if (youtubeId.lastIndexOf('?') > -1) {
    youtubeId = youtubeId.split('?')[0];
  }
  return youtubeId;
}

function getIdVideoVimeo(url) {
  let result = '';
  const index = url.lastIndexOf('/') + 1;
  result = url.substring(index);
  return result;
}

function isUrlFromYoutube(url) {
  return url.match(/^http(s)?:\/\/(www.)?youtube|youtu\.be/);
}

function isUrlFromVimeo(url) {
  return url.match(/^http(s)?:\/\/(www.)?vimeo\.com|player\.vimeo\.com/);
}

function isUrlVideoFlv(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/(^http(s)?|^rtmp):\/\/.*\.flv$/);
  } catch (error) {
    return false;
  }
}

function isUrlVideoSwf(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/(^http(s)?):\/\/.*\.swf$/);
  } catch (error) {
    return false;
  }
}

function isUrlVideoMP4(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/(^http(s)?|^rtmp):\/\/.*\.(mp4|MP4)$/);
  } catch (error) {
    return false;
  }
}

function isUrlVideoM3U8(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/(^http(s)?|^rtmp):\/\/.*\.m3u8$/);
  } catch (error) {
    return false;
  }
}

function isUrlAudioMP3(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/(^http(s)?|^rtmp):\/\/.*\.mp3$/);
  } catch (error) {
    return false;
  }
}

function isUrlVideoMOV(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/^(http(s)?):\/\/.*\.mov$/);
  } catch (error) {
    return false;
  }
}

function isUrlVideoWEBM(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/(^http(s)?):\/\/.*\.webm$/);
  } catch (error) {
    return false;
  }
}

function isRTMPProtocol(url) {
  try {
    const urlWithoutParams = url.split('?');
    return urlWithoutParams[0].match(/^rtmp:\/\/.*\.(mp4|flv)$/);
  } catch (error) {
    return false;
  }
}

function isUrlVideoJavascript(url) {
  try {
    if (url.indexOf('.js?') > 0) {
      const urlWithoutParams = url.split('?');
      return urlWithoutParams[0].match(/^http(s)?:\/\/.*\.js(\?)?/);
    }
    if (url.indexOf('.js#') > 0) {
      // puesto por las urls de YUME
      const urlWithoutParams = url.split('#');
      return urlWithoutParams[0].match(/^http(s)?:\/\/.*\.js(#)?/);
    }
    if (url.match(/\.js$/)) {
      return url;
    }
  } catch (error) {
    return false;
  }
  return false;
}

export default function getTypeVideoByUrl(urlOrigin, isPubli) {
  const urlConfiguration = {};
  if (typeof urlOrigin !== 'string') return urlConfiguration;
  const url = checkProtocol(urlOrigin);

  urlConfiguration.source = SOURCE_TYPE.EXTERNAL;
  if (isIMAVideo(url)) {
    const urlParsed = parserTag(url);
    urlConfiguration.idVideo = urlParsed;
    urlConfiguration.type = VIDEO_TYPE.IMA;
  } else if (isUrlFromYoutube(url)) {
    urlConfiguration.idVideo = getIdVideoYoutube(url);
    urlConfiguration.type = VIDEO_TYPE.YOUTUBE;
  } else if (isUrlFromVimeo(url)) {
    urlConfiguration.idVideo = getIdVideoVimeo(url);
    urlConfiguration.type = VIDEO_TYPE.VIMEO;
  } else if (isRTMPProtocol(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.FLASH;
  } else if (isUrlVideoFlv(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.FLASH;
  } else if (isUrlVideoSwf(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.SWF;
  } else if (isUrlVideoMP4(url) || isUrlVideoWEBM(url) || isUrlVideoMOV(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.HTML;
    if (!isExternalVideo(url)) {
      urlConfiguration.source = SOURCE_TYPE.SMARTY;
    }
  } else if (isUrlAudioMP3(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.AUDIO;
  } else if (isUrlVideoJavascript(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.JAVASCRIPT;
  } else if (isUrlVideoM3U8(url)) {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = VIDEO_TYPE.HLS;
  } else {
    urlConfiguration.idVideo = url;
    urlConfiguration.type = isPubli ? VIDEO_TYPE.UNKNOWN : VIDEO_TYPE.HTML;
  }

  if (urlConfiguration.idVideo.indexOf('//') === 0) {
    // eslint-disable-next-line no-param-reassign
    urlConfiguration.idVideo = `https:${urlConfiguration.idVideo}`;
  }
  return urlConfiguration;
}
